module.exports = __webpack_public_path__ + "img/modern_pink_print.799860e9.png";